<template>
  <div class="restart-btn-relative" :class="[button ? 'restart-btn--btn' : '']">
    <div class="back-btn-wrapper">
      <button class="back-btn-wrapper-button" @click="restart">
        Relancer
      </button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    button: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    restart() {
      this.$store.dispatch("restart");
    }
  }
};
</script>

<style lang="scss" scoped>
.restart-btn-relative {
  @include media("<tablet") {
    background: $c-white;
    border-radius: #{$s-border-radius - 1} 0 0 0;
    padding: 10px 20px;
    min-height: 56px;
  }

  &:not(.restart-btn--btn) {
    .back-btn-wrapper {
      background: $c-white;
      color: $c-text;
      border-radius: #{$s-border-radius - 1} 0 0 0;
      padding: 10px 20px;

      @include media(">=desktop") {
        width: 145px;
        height: 89px;
        background: url("~@/assets/images/back-button-bg.svg") no-repeat top
          left/contain;
        padding: 16px 5px 10px;
      }
    }
  }
}

.back-btn-wrapper-button {
  background: none;
  border: none;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  color: $c-text;
  transition: $s-transition;

  @include media(">=desktop") {
    font-size: 14px;
  }

  &::before {
    content: "";
    display: block;
    mask: url("~@/assets/images/restart-button-icon.svg") no-repeat
      center/contain;
    width: 34px;
    height: 29px;
    background: currentColor;
    margin-right: 10px;
    transition: all 0.8s $s-transition-easing-inoutbounce;

    @include ie-only {
      mask: none;
      background: url("~@/assets/images/restart-button-icon.svg") no-repeat
        center/contain;
    }
  }

  &:active,
  &:focus {
    outline: 0;
  }

  &:hover {
    color: $c-primary;

    &::before {
      transform: rotate(-180deg);
    }
  }
}

.restart-btn--btn {
  position: relative;
  background: $c-primary-contrast;
  color: $c-primary;
  border-radius: 30px;
  border: none;
  cursor: pointer;
  transition: all $s-transition;

  &:active,
  &:focus {
    outline: none;
  }

  &:hover {
    box-shadow: 0 0 0 5px darken($c-primary, 5%);
  }

  .back-btn-wrapper-button {
    color: currentColor;
    padding: 14px 30px 14px 20px;

    @include media(">=desktop") {
      font-size: 18px;
    }
  }
}
</style>
